<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      colorOptions: [
        {
          label: 'Green',
          value: 'green'
        },
        {
          label: 'Blue',
          value: 'blue'
        },
        {
          label: 'Purple',
          value: 'purple'
        },
        {
          label: 'Orange',
          value: 'orange'
        },
        {
          label: 'Black',
          value: 'black'
        }
      ]
    }
  },
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.items)) {
        this.$set(this.form, 'items', [])
      }
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Select({
              label: 'Color',
              modelPath: [this, 'form', 'color'],
              options: this.colorOptions
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => {
                return {
                  headerLabel: 'Underline item',
                  fields: [
                    new fields.WYSIWYG({
                      label: 'Content',
                      modelPath: [this, 'form', 'items', i, 'content'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
